<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'FILTER.TITLE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button color="toolbar-button" (click)="cancel()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item lines="none">
      <ion-label>{{ 'FILTER.CONNECTOR_TYPES' | translate }}</ion-label>

      <ion-button fill="clear" slot="end" (click)="openAlert()">
        {{ 'FILTER.SELECT_CONNECTORS' | translate }}
        <ion-icon name="caret-down-outline" color="medium"></ion-icon>
      </ion-button>
    </ion-item>
    <div class="ion-padding-horizontal ion-padding-bottom">
      <span *ngFor="let conn of connectors">
        <ion-chip *ngIf="isSelected(conn.Name)">
          <i class="chip-connector con-{{ conn.IconName }}"></i>
          <ion-label class="chip-name">{{ conn.Name }}</ion-label>
          <ion-icon
            name="close-circle"
            (click)="removeConnector(conn.Name)"></ion-icon>
        </ion-chip>
      </span>
    </div>
  </ion-list>

  <ion-list>
    <ion-item lines="none">
      <ion-label>{{ 'FILTER.CHARGING_SPEED' | translate }}</ion-label>
      <ion-badge slot="end" color="primary">
        <ng-container *ngIf="filters.kWh.lower === filters.kWh.upper">
          {{ filters.kWh.upper }}
        </ng-container>
        <ng-container *ngIf="filters.kWh.lower !== filters.kWh.upper">
          {{ filters.kWh.lower }} – {{ filters.kWh.upper }}
        </ng-container>
        kW
      </ion-badge>
    </ion-item>
    <ion-item>
      <ion-range
        min="0"
        max="4"
        [(ngModel)]="kWh"
        (ionInput)="watchKWH()"
        snaps="true"
        color="primary"
        dualKnobs="true">
        <ion-icon size="small" slot="start" name="flash"></ion-icon>
        <ion-icon slot="end" name="flash"></ion-icon>
      </ion-range>
    </ion-item>
  </ion-list>
  <ion-list *ngIf="!fromMap">
    <ion-item lines="none">
      <ion-label>{{ 'FILTER.SEARCH_RADIUS' | translate }}</ion-label>
      <ion-badge slot="end" color="primary">{{ filters.range }} km</ion-badge>
    </ion-item>
    <ion-item>
      <ion-range min="1" max="20" [(ngModel)]="filters.range" color="primary">
        <ion-icon size="small" slot="start" name="disc-outline"></ion-icon>
        <ion-icon slot="end" name="disc-outline"></ion-icon>
      </ion-range>
    </ion-item>
  </ion-list>
  <div class="ion-padding">
    <ion-button
      class="ion-margin-bottom"
      expand="block"
      color="primary"
      (click)="cancel()">
      Ok
    </ion-button>
    <ion-button expand="block" color="light" (click)="resetFilters()">
      {{ 'FILTER.RESET_FILTERS' | translate }}
    </ion-button>
  </div>
</ion-content>
